import { SwitchProps as Mui5SwitchProps } from '@mui/material/Switch'

import { FC } from 'react'
import { StyledHelperTextSwitch3 } from '../other/common/StyledHelperText'
import { StyledLabelTextSwitch3 } from '../other/common/StyledLabelText'
import { styled } from '../styles'
import { Switch } from './Switch'

const StyledSwitchWrapperEnd = styled('span')<Switch3Props>(({ size }) => ({
  display: 'flex',
  flexDirection: 'column',
}))

const StyledSwitchWrapperStart = styled('span')<Switch3Props>(({ size }) => ({
  width: size === 'small' ? 180 : 210,
  display: 'flex',
  flexDirection: 'column',
}))

export type Switch3Props = Omit<Mui5SwitchProps, 'icon' | 'checkedIcon' | 'color'> & {
  helperText?: string
  labelPlacement?: 'end' | 'start'
}

export const Switch3: FC<Switch3Props> = (props) => {
  let { title, id, value, helperText, labelPlacement = 'end', size, ...rest } = props
  const StyledSwitchWrapper = labelPlacement === 'start' ? StyledSwitchWrapperStart : StyledSwitchWrapperEnd
  return (
    <StyledSwitchWrapper size={size}>
      <StyledLabelTextSwitch3
        size={size}
        sx={{
          ...(labelPlacement === 'start' && { justifyContent: 'space-between', marginLeft: 0, marginRight: 0 }),
        }}
        label={title}
        labelPlacement={labelPlacement}
        key={id}
        value={value}
        control={
          <Switch
            size={size}
            sx={{
              padding: 0,
              ...(labelPlacement === 'end' && { marginRight: '8px', marginLeft: '0px' }),
              ...(labelPlacement === 'start' && { marginLeft: '8px', marginRight: '0px' }),
            }}
            {...rest}
          />
        }
      />
      {helperText && (
        <StyledHelperTextSwitch3 size={size} labelPlacement={labelPlacement}>
          {helperText}
        </StyledHelperTextSwitch3>
      )}
    </StyledSwitchWrapper>
  )
}
